import React, { useState } from 'react';
import { ManageSeparationsDialog } from '.';
import { Button } from '../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../Core/InjectedPropsContext';
import { ManageSeparationsComponentProps } from './types';

// Button to bring up Manage Separations dialog
// Currently assumes that the "root" level for this worksheet is "data"
// Have to fix if we ever make this worksheet an embedded worksheet in another test.
let ManageSeparationsButton: React.FC<ManageSeparationsComponentProps> = ({
  maxSeparations,
  defaultSieveSizes,
  notEditableSeparations,
  disabled,
}) => {
  const [showManageSeparationsDialog, setShowManageSeparationsDialog] = useState(false);

  return (
    <>
      <Button disabled={disabled} onClick={() => setShowManageSeparationsDialog(true)}>
        Manage Separations
      </Button>

      <NamePrefixModifier namePrefix="data">
        <ManageSeparationsDialog
          maxSeparations={maxSeparations}
          defaultSieveSizes={defaultSieveSizes}
          notEditableSeparations={notEditableSeparations}
          visible={showManageSeparationsDialog}
          onClose={() => setShowManageSeparationsDialog(false)}
        />
      </NamePrefixModifier>
    </>
  );
};
ManageSeparationsButton = withInjectedProps(ManageSeparationsButton);

export { ManageSeparationsButton };
